import React from 'react';

import FieldMultiPhone from '../common/FieldMultiPhone';
import FieldMultiValue from '../common/FieldMultiValue';
import FieldSingleAddress from '../common/FieldSingleAddress';

class ProjectContactDetails extends React.Component {

  constructor(props) { super(props); this.state = { inValid: props.inValid }; }

  UNSAFE_componentWillReceiveProps(props) {
    if(JSON.stringify(this.state.inValid) !== JSON.stringify(props.inValid)) {
      this.setState({ ...this.state, inValid: props.inValid ? props.inValid : {} })
    }
  }

  render() {
    const fields = this.props.model.fields;
    const project = this.props.project;
    const onValueChange = this.props.onValueChange;
    return (
      <>
        <div className="formhead col-md-12"><h2>Contact Information</h2></div>

        <FieldMultiPhone key="phone" id="phone" field={fields.phone}
          value={project.phone} onValueChange={onValueChange} inValid={this.state.inValid} />
        
        <FieldMultiValue key="email" id="email" field={fields.email} value={project.email}
          onValueChange={onValueChange} inValid={this.state.inValid} />

        { /*
        <FieldMultiValue key="site" id="site" field={fields.site} value={lead.site}
          onValueChange={onValueChange} inValid={this.state.inValid} /> */}
          
        <FieldSingleAddress key="address" id="address" field={fields.address} value={project.address}
          onValueChange={onValueChange} inValid={this.state.inValid} />
        
        {/* <FieldText key="area" id="area" field={fields.area}
          value={project.area} onValueChange={onValueChange} inValid={inValid} /> */}
{/* 
        <FieldText key="landmark" id="landmark" field={fields.landmark}
          value={property.relandmarknt} onValueChange={onValueChange} inValid={inValid} /> */}

      </>
    );
  }
}

export default ProjectContactDetails;